import React from "react";
import { useState } from "react";

const WrapperWithTabs = ({
  tabBarOptions = [],
  commonProps = {},
  componentBasedProps = {},
  wrapperClassName = "",
}) => {
  const [selectedTab, setSelectedTab] = useState(tabBarOptions[0]);
  const onTabSelect = (tab) => {
    setSelectedTab(tab);
  };
  

  const props = componentBasedProps?.[selectedTab?.id] || {};

  return (
    <div className={`tab-bar-wraper ${wrapperClassName}`}>
      <div className="flex gap-x-4">
        {tabBarOptions.map((item, index) => {
          return (
            <span
              className={`tab-option font-family-medium font-size-small ${
                selectedTab?.id === item?.id ? "tab-option-active" : ""
              }`}
              key={"tab-option-" + index}
              onClick={() => onTabSelect(item)}
            >
              {item?.title}
            </span>
          );
        })}
      </div>
      <div className="component-wrapper">
        {/* {tabBarOptions.map(i => {
          return (
            <div key={"tab-"+i.id} style={{display: i.id === selectedTab.id ? "block"  :  "none"}}>
              <i.Component {...commonProps} {...props} />
            </div>
          )
        })} */}
        {selectedTab.Component ? (
          <selectedTab.Component {...commonProps} {...props} />
        ) : null}
      </div>
    </div>
  );
};

export default WrapperWithTabs;
